//import { useState } from 'react'
import { useClient, useDictionary, useOrder } from "@adamlip/okeoke.client";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { useParams } from "react-router-dom";
import GridLoader from "react-spinners/GridLoader";

function OrderPayment() {
  const { id } = useParams();
  const { getValue } = useDictionary();
  const { locations } = useClient();
  const {
    order,
    isReady,
    paymentsTotal,
    takeAway,
    insertTimestamp,
    orderNumber,
    requestedReadyTime,
    notes,
    discountPrice,
  } = useOrder(null, id);
  const location = locations?.[order?.locationUUID];

  //console.log(isReady)

  if (!isReady || order == null)
    return (
      <div className="order-payment-container">
        <GridLoader loading={true} color={"grey"} />
      </div>
    );

  return (
    <div className="order-payment-container">
      <div className="order-details-orderNumber font-extraLarge">{`${getValue(
        "app_v2_order"
      )} #${orderNumber}`}</div>
      <div className="order-details-header">
        <div className="order-details-title font-large">
          {getValue("app_v2_orderDetails_title")}
        </div>
        <div className="order-details-data-root">
          <div className="order-details-block">
            <div className="order-details-label">
              {getValue("app_v2_orderDetails_location")}:
            </div>
            <div className="order-details-data">{location?.name}</div>
          </div>
          <div className="order-details-block">
            <div className="order-details-label">
              {getValue("app_v2_orderDetails_takeAwayLabel")}
            </div>
            <div className="order-details-data">
              {takeAway
                ? getValue("app_v2_orderDetails_takeAway_yes")
                : getValue("app_v2_orderDetails_takeAway_no")}
            </div>
          </div>
          <div className="order-details-block">
            <div className="order-details-label">
              {getValue("app_v2_orderDetails_timestamp")}
            </div>
            <div className="order-details-data">
              {moment(insertTimestamp).format("YYYY-MM-DD HH:mm")}
            </div>
          </div>
          {
            <div className="order-details-block">
              <div className="order-details-label">
                {getValue("app_v2_orderDetails_readyTime")}:
              </div>
              <div className="order-details-data">
                {requestedReadyTime != null
                  ? requestedReadyTime
                  : "lehető leghamarabb"}
              </div>
            </div>
          }
          {notes != null && (
            <div className="order-notes font-smallest">{notes}</div>
          )}
          <div className="order-details-block">
            <div className="order-details-label">
              {getValue("app_v2_orderPayments_basketPrice")}:
            </div>
            <div className="order-details-data">
              <NumericFormat
                value={+discountPrice}
                decimalSeparator=","
                suffix=" Ft"
                thousandSeparator="."
                displayType="text"
              />
            </div>
          </div>
          <div className="order-details-block">
            <div className="order-details-label">
              {getValue("app_v2_orderPayments_totalPrice")}:
            </div>
            <div className="order-details-data">
              <NumericFormat
                value={+paymentsTotal}
                decimalSeparator=","
                suffix=" Ft"
                thousandSeparator="."
                displayType="text"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default OrderPayment;
